import { ClientBusinessLine } from '../enums/ClientBusinessLine';

/**
 * mapToClientBusinessLine
 *
 * @description
 * Map a value from the user config object to the enum value used in this
 * front-end
 */
export function mapToClientBusinessLine(value: string): ClientBusinessLine {
    switch (value.toLowerCase()) {
        case 'other':
            return ClientBusinessLine.other;
        case 'mbweb':
            return ClientBusinessLine.proctor;
        case 'qlweb':
        default:
            return ClientBusinessLine.default;
    }
}
